<div class="panel panel-thead">
	<div class="row no-gutters">
		@if (isDiary()) {
		<div data-testid="SUBSYS5_HISTORYTABLE_HEADER_EFFECTIVEDATE" class="col"
			[class.active]="activeColumn() === FIELDS.effectiveDate">
			<tsp-sortable-header [name]="FIELDS.effectiveDate" (sort)="onSort($event)">
				{{ labels().HISTORY_TABLE_COMPONENT_EFFECTIVE_DATE }}
			</tsp-sortable-header>
		</div>
		}
		<div data-testid="SUBSYS5_HISTORYTABLE_HEADER_SCHEDULEDATE" class="col"
			[class.active]="isDiary() ? activeColumn() === FIELDS.scheduledDate : activeColumn() === FIELDS.anomalyDate">
			<tsp-sortable-header [name]="isDiary() ? FIELDS.scheduledDate : FIELDS.anomalyDate" (sort)="onSort($event)">
				{{ labels().HISTORY_TABLE_COMPONENT_SCHEDULED_DATE }}
			</tsp-sortable-header>
		</div>
		<div data-testid="SUBSYS5_HISTORYTABLE_HEADER_TYPE" class="col no-link">
			{{ labels().HISTORY_TABLE_COMPONENT_TYPE }}
		</div>
		<div data-testid="SUBSYS5_HISTORYTABLE_HEADER_FRAMEID" class="col"
			[class.active]="activeColumn() === FIELDS.frameId">
			<tsp-sortable-header [name]="FIELDS.frameId" (sort)="onSort($event)">
				{{ labels().HISTORY_TABLE_COMPONENT_FRAME_ID }}
			</tsp-sortable-header>
		</div>
		<div data-testid="SUBSYS5_HISTORYTABLE_HEADER_MESSAGE" class="col no-link">
			{{ labels().HISTORY_TABLE_COMPONENT_MESSAGE }}
		</div>
		@if (isReadCheckboxVisible()) {
		<div class="col stretch-col no-link">
			<div class="form-group w-auto pb-0">
				<div class="custom-control custom-checkbox custom-control-inline pt-0">
					<input data-testid="SUBSYS5_HISTORYTABLE_HEADER_ALL_INPUT" type="checkbox" name="all"
						class="custom-control-input" id="all" [checked]="isAllSelected()" (change)="selectAll($event)">
					<label data-testid="SUBSYS5_HISTORYTABLE_HEADER_ALL_LBL" class="custom-control-label" for="all">
						{{ labels().HISTORY_TABLE_COMPONENT_SELECT_ALL }}
					</label>
				</div>
			</div>
		</div>
		}
	</div>
</div>

@for (item of items(); track $index) {
<div class="panel panel-tr">
	<div class="row no-gutters" [class.fw-bold]="!isDiary() && !item.isRead">
		@if (isDiary()) {
		<div data-testid="SUBSYS5_HISTORYTABLE_CELL_EFFECTIVEDATE" class="col">
			{{ item.effectiveDate | convertDate:false }} {{ item.effectiveDate | date:'HH:mm':'UTC'}}
		</div>
		}
		<div data-testid="SUBSYS5_HISTORYTABLE_CELL_SCHEDULEDATE" class="col">
			{{ (item.scheduledDate | convertDate:false) ?? '--' }}
			{{ !isDiary() && item.type === LOG_TYPE.PinSiteCareDone ? '' : item.scheduledDate | date:'HH:mm':'UTC' }}
		</div>
		<div data-testid="SUBSYS5_HISTORYTABLE_CELL_TYPE" class="col">
			<div class="d-flex justify-content-between align-items-center m-auto" style="max-width: 30rem;">
				<img [src]="logTypeIcon(item.type)" alt="log type icon" height="28px">
				<span class="px-3">{{ item.type | logTypeLabel }}</span>
				<img [src]="logStatusIcon(item.status!)" alt="log status icon" height="28px">
			</div>
		</div>
		<div data-testid="SUBSYS5_HISTORYTABLE_CELL_FRAMEID" class="col">
			{{ isFrameVisible(item.type) ? item.frameID : '' }}
		</div>
		<div data-testid="SUBSYS5_HISTORYTABLE_CELL_MESSAGE" class="col">
			{{ item.message | diaryMessage:item.type }}
		</div>
		@if (isReadCheckboxVisible()) {
		<div class="col stretch-col">
			<div class="form-group w-auto pb-0">
				<div class="custom-control custom-checkbox custom-control-inline pt-0">
					<input data-testid="SUBSYS5_HISTORYTABLE_CELL_CHECK_INPUT" type="checkbox" name="item" #checkbox
						class="custom-control-input" [id]="'item_'+$index" [checked]="item.isSelected"
						(change)="select(item, checkbox.checked)">
					<label class="custom-control-label" [for]="'item_'+$index">&nbsp;</label>
				</div>
			</div>
		</div>
		}
	</div>
</div>
}